import { DEFAULT_LOCATIONS, EBAY, DROPDOWN } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token bc40210d6a34fd165e32b092239f6930043eac81',
  staging: 'Token e0d0e3f04e7e324151fae80fbe18c0371f135772',
  prod: 'Token e227d041c3327cb2b12a09063037199bdfb1db35',
};
const token = selectToken(apiTokens);
const ebayConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'ebay',
  API_TOKEN: token,
  EMBOLD_CLIENT: EBAY,
  // login
  SHOW_REGION_SELECTOR: true,
  NETWORKS: {},
  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.SanJose },
  LOGIN_NETWORK_NAME: 'ebayUserId',
  // content
  DISPLAY_NAME: 'Ebay',
  FORM_VARIANT: DROPDOWN,
  NO_WELCOME_LINK: false,
};
export default ebayConfig;
